import { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { OptionProps } from "@/types";
import { FloatingLabel, Form } from "react-bootstrap";

interface FloatingSelectProps {
  name: string;
  label: string;
  options: OptionProps[];
  register: UseFormRegisterReturn;
  error?: FieldError;
  className?: string;
}

export default function FloatingSelect({
  name,
  label,
  options,
  register,
  error,
  className = "mb-2",
}: FloatingSelectProps) {
  return (
    <FloatingLabel controlId={name} label={label} className={className}>
      <Form.Select isInvalid={!!error} {...register}>
        <option value="">-- select --</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Form.Select>
      {error?.message && <Form.Control.Feedback type="invalid">{error.message}</Form.Control.Feedback>}
    </FloatingLabel>
  );
}
